import { getDefaultExportFromCjs } from "./_commonjsHelpers.js";
import { __require as requireSrc } from "../packages/model/node_modules/postcss-discard-duplicates/src/index.js";
var srcExports = requireSrc();
const postcssDuplicates = /* @__PURE__ */ getDefaultExportFromCjs(srcExports);
export {
  postcssDuplicates as default
};
//# sourceMappingURL=index.js.map
